export const IconDOC=()=> {
  return (
    <div>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_85_164)">
          <path
            d="M8.45007 16.875C8.35297 16.875 8.25588 16.8928 8.16325 16.9304C7.63675 17.1441 7.08303 17.2812 6.50007 17.2812C5.9171 17.2812 5.36338 17.1441 4.83647 16.9304C4.74385 16.8928 4.64716 16.875 4.55007 16.875C2.02888 16.875 -0.0133406 19.4384 6.56288e-05 22.594C0.00575313 23.9275 0.882847 25 1.95007 25H11.0501C12.1173 25 12.9944 23.9275 13.0001 22.594C13.0135 19.4384 10.9713 16.875 8.45007 16.875ZM6.50007 15.25C8.654 15.25 10.4001 13.0674 10.4001 10.375C10.4001 7.68258 8.654 5.5 6.50007 5.5C4.34613 5.5 2.60007 7.68258 2.60007 10.375C2.60007 13.0674 4.34613 15.25 6.50007 15.25ZM24.0501 -1H8.45007C7.37472 -1 6.50007 0.129883 6.50007 1.51824V3.875C7.4515 3.875 8.33225 4.2193 9.10007 4.77891V2.25H23.4001V16.875H20.8001V13.625H15.6001V16.875H12.5028C13.2788 17.7225 13.8483 18.8418 14.1152 20.125H24.0501C25.1254 20.125 26.0001 18.9951 26.0001 17.6068V1.51824C26.0001 0.129883 25.1254 -1 24.0501 -1Z"
            fill="#12B0DF"
          />
        </g>
        <defs>
          <clipPath id="clip0_85_164">
            <rect width="26" height="26" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
export const IconSearch=()=> {
  return (
    <div>
      <svg
        width="29"
        height="29"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_291_31)">
          <path
            d="M22.0165 19.3949C23.832 16.9175 24.6452 13.8459 24.2933 10.7946C23.9414 7.74334 22.4504 4.93745 20.1185 2.93831C17.7867 0.939171 14.786 -0.105799 11.7168 0.0124631C8.64757 0.130725 5.73619 1.4035 3.5651 3.57615C1.394 5.74879 0.123313 8.66109 0.00724741 11.7304C-0.108819 14.7997 0.938298 17.7996 2.93911 20.13C4.93992 22.4604 7.74686 23.9495 10.7984 24.2992C13.8499 24.6489 16.9209 23.8335 19.3971 22.0162H19.3952C19.4515 22.0912 19.5115 22.1624 19.579 22.2318L26.7977 29.4506C27.1493 29.8024 27.6262 30.0001 28.1236 30.0003C28.621 30.0005 29.0981 29.8031 29.4499 29.4515C29.8017 29.0999 29.9995 28.623 29.9997 28.1256C29.9998 27.6282 29.8024 27.1511 29.4508 26.7993L22.2321 19.5806C22.1651 19.5127 22.093 19.45 22.0165 19.3931V19.3949ZM22.5002 12.1874C22.5002 13.5417 22.2335 14.8827 21.7152 16.1339C21.197 17.385 20.4374 18.5219 19.4798 19.4795C18.5222 20.4371 17.3853 21.1967 16.1341 21.715C14.883 22.2332 13.542 22.4999 12.1877 22.4999C10.8335 22.4999 9.49247 22.2332 8.2413 21.715C6.99013 21.1967 5.85328 20.4371 4.89568 19.4795C3.93808 18.5219 3.17846 17.385 2.66021 16.1339C2.14196 14.8827 1.87522 13.5417 1.87522 12.1874C1.87522 9.4524 2.96171 6.82938 4.89568 4.89541C6.82965 2.96144 9.45267 1.87494 12.1877 1.87494C14.9228 1.87494 17.5458 2.96144 19.4798 4.89541C21.4137 6.82938 22.5002 9.4524 22.5002 12.1874V12.1874Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_291_31">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export const IconTeacher=()=> {
  return (
    <div>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 0.8125C6.5 0.597012 6.4144 0.390349 6.26202 0.237976C6.10965 0.0856024 5.90299 0 5.6875 0C5.47201 0 5.26535 0.0856024 5.11298 0.237976C4.9606 0.390349 4.875 0.597012 4.875 0.8125V1.625H3.25C2.38805 1.625 1.5614 1.96741 0.951903 2.5769C0.34241 3.1864 0 4.01305 0 4.875L0 6.5H26V4.875C26 4.01305 25.6576 3.1864 25.0481 2.5769C24.4386 1.96741 23.612 1.625 22.75 1.625H21.125V0.8125C21.125 0.597012 21.0394 0.390349 20.887 0.237976C20.7347 0.0856024 20.528 0 20.3125 0C20.097 0 19.8903 0.0856024 19.738 0.237976C19.5856 0.390349 19.5 0.597012 19.5 0.8125V1.625H6.5V0.8125ZM26 22.75C26 23.612 25.6576 24.4386 25.0481 25.0481C24.4386 25.6576 23.612 26 22.75 26H3.25C2.38805 26 1.5614 25.6576 0.951903 25.0481C0.34241 24.4386 0 23.612 0 22.75V8.125H26V22.75ZM18.2244 12.7644C18.3184 12.7689 18.4124 12.7543 18.5007 12.7215C18.5889 12.6886 18.6696 12.6382 18.7377 12.5732C18.8059 12.5083 18.8602 12.4301 18.8973 12.3436C18.9344 12.257 18.9535 12.1639 18.9535 12.0697C18.9535 11.9755 18.9344 11.8823 18.8973 11.7958C18.8602 11.7092 18.8059 11.6311 18.7377 11.5662C18.6696 11.5012 18.5889 11.4508 18.5007 11.4179C18.4124 11.385 18.3184 11.3705 18.2244 11.375C18.1324 11.3741 18.0411 11.3916 17.956 11.4264C17.8708 11.4612 17.7934 11.5127 17.7283 11.5777C17.6633 11.6428 17.6119 11.7202 17.577 11.8053C17.5422 11.8905 17.5248 11.9817 17.5256 12.0737C17.5256 12.4605 17.8376 12.7644 18.2244 12.7644ZM18.7704 13.6793H17.6784V20.3499H18.7704V13.6793ZM7.6115 20.3499V16.6124H11.2856V15.6211H7.6115V12.6766H11.6155V11.6854H6.5V20.3499H7.6115ZM12.9675 20.3499H14.066V16.2175C14.066 15.3172 14.4349 14.5811 15.6146 14.5811C15.8177 14.5811 16.0339 14.5876 16.1493 14.6055V13.6094C16.0126 13.5888 15.8747 13.578 15.7365 13.5769C14.7907 13.5769 14.2886 14.0969 14.092 14.4983H14.0595V13.6793H12.9675V20.3499Z"
          fill="#12B0DF"
        />
      </svg>
    </div>
  );
}

